<template>
  <div :class="wrapperClasses">
    <div class="listing">
      <b-field>
        <b-radio-button v-model="sectionFilter" native-value="site" type="is-light">Site wide</b-radio-button>
        <b-radio-button
          v-model="sectionFilter"
          native-value="submission"
          type="is-light"
        >Application</b-radio-button>
        <b-radio-button v-model="sectionFilter" native-value="work" type="is-light">Works</b-radio-button>
        <b-radio-button v-model="sectionFilter" native-value="mediaitem" type="is-light">Media items</b-radio-button>
        <b-radio-button v-model="sectionFilter" native-value="payment" type="is-light">Payment</b-radio-button>
        <b-radio-button v-model="sectionFilter" native-value="survey" type="is-light">Survey</b-radio-button>
        <b-radio-button v-model="sectionFilter" native-value="completion" type="is-light">Completion</b-radio-button>
        <b-radio-button v-model="sectionFilter" native-value="admin" type="is-light">Admin</b-radio-button>
        <b-radio-button v-model="sectionFilter" native-value="help" type="is-light">Help</b-radio-button>
        <b-radio-button v-model="sectionFilter" native-value="all" type="is-light">All</b-radio-button>
      </b-field>
      <b-table :data="items" :row-class="(row, index) => assignRowClasses(row, index)">
        <template slot-scope="props">
          <b-table-column class="key" field="key" label="Key" sortable>
            <span v-if="showAll" class="section">{{props.row.key|sectionPart}}</span>
            <span class="name">{{props.row.key|namePart}}</span>
          </b-table-column>
          <b-table-column field="text" label="Text" sortable>{{props.row.value|truncate}}</b-table-column>
          <b-table-column field="format" label="Format" sortable>{{props.row.format}}</b-table-column>
          <b-table-column field="text" label="Characters" sortable>{{props.row.value|chars}}</b-table-column>
          <b-table-column field="_id" label="Edit">
            <span class="edit" v-on:click="showSnippet(props.row.key)">
              <b-icon icon="square-edit-outline" />
            </span>
          </b-table-column>
        </template>
      </b-table>
    </div>
    <SnippetDetail v-if="showDetail" :snippet="snippet" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getSnippets } from "../api/methods";
import filters from "../mixins/filters";
import SnippetDetail from "./SnippetDetail";
import { bus } from "../main";

export default {
  name: "SnippetList",
  components: {
    SnippetDetail
  },
  mixins: [filters],
  data() {
    return {
      items: [],
      sourceList: [],
      num: 0,
      sectionFilter: "submission",
      total: 0,
      criteria: {},
      showDetail: false,
      currKey: "",
      snippet: {
        type: Object,
        default: {
          _id: "",
          key: "",
          format: "",
          value: "",
          createdAt: null,
          modifiedAt: null
        }
      }
    };
  },
  computed: {
    ...mapGetters(["snippets"]),
    wrapperClasses() {
      let cls = ["snippets"];
      if (this.showDetail) {
        cls.push("show-detail");
      }
      return cls;
    },
    numItems() {
      return this.items.length;
    },
    showAll() {
      return (
        this.sectionFilter.length < 3 ||
        this.sectionFilter.toLowerCase() === "all"
      );
    }
  },
  created() {
    bus.$on("escape", val => {
      if (val) {
        this.close();
      }
    });
  },
  mounted() {
    if (this.$route.path) {
      const parts = this.$route.path.substring(1).split("/");
      if (parts.length > 1) {
        this.sectionFilter = parts[1];
        if (parts.length > 2) {
          this.currKey = parts[2];
        }
      }
    }
    this.mapSnippets();
    setTimeout(() => {
      this.mapSnippets();
    }, 500);
  },
  watch: {
    sectionFilter(newVal, prevVal) {
      if (newVal !== prevVal) {
        this.remapSnippets();
        const newPath = "/snippets/" + newVal;
        if (
          newPath !== this.$route.path &&
          /^\/?snippets(\/\w+)?$/.test(this.$route.path)
        ) {
          this.$router.push(newPath);
        }
      }
    }
  },
  filters: {
    namePart(val) {
      let parts = val.split("__");
      if (val.indexOf("_help") < 6) {
        parts.shift();
      } else {
        switch (parts[0]) {
          case "mediaitem":
            parts[0] = "media item";
            break;
        }
      }
      const name = parts.join(" ").replace(/_+/g, " ");
      return name;
    },
    sectionPart(val) {
      const prefix = val.split("__").shift();
      let section = prefix;
      switch (prefix) {
        case "submission":
          section = "application details";
          break;
        case "work":
          section = "Works";
          break;
        case "mediaitem":
          section = "Media items";
          break;
        case "site":
          section = "Site wide";
          break;
        case "payment":
          section = "Payment";
          break;
        case "completion":
          section = "Completion";
          break;
        case "survey":
          section = "Survey";
          break;
      }
      return section;
    }
  },
  methods: {
    mapSnippets(remap) {
      if (
        (this.items.length < 1 || remap === true) &&
        this.snippets instanceof Array &&
        this.snippets.length > 0
      ) {
        if (remap !== true) {
          getSnippets().then(data => {
            if (data.items instanceof Array) {
              this.assignAll(data.items);
              this.filterItems();
            }
          });
        } else {
          this.filterItems();
        }
      }
    },
    assignAll(items) {
      if (items instanceof Array) {
        this.sourceList = items;
        if (this.currKey.length > 3) {
          this.showSnippet(this.currKey);
        }
        this.filterItems();
      }
    },
    filterItems() {
      const sectionKey =
        this.sectionFilter.length > 2
          ? this.sectionFilter.toLowerCase()
          : "all";

      switch (sectionKey) {
        case "all":
        case "-":
          this.items = this.sourceList;
          break;
        default:
          this.items = this.sourceList.filter(s => {
            switch (this.sectionFilter) {
              case "help":
                return s.key.indexOf("_" + sectionKey) > 3;
              case "submission":
                return (
                  s.key.indexOf(sectionKey + "__") === 0 ||
                  s.key.indexOf("overlay_") === 0
                );
              default:
                return s.key.indexOf(sectionKey + "__") === 0;
            }
          });
          break;
      }
    },
    remapSnippets() {
      this.mapSnippets(true);
    },
    showSnippet(key) {
      const snippet = this.items.find(s => s.key === key);
      if (snippet instanceof Object) {
        if (snippet.key) {
          const source = this.sourceList.find(s => s.key === key);
          if (source) {
            this.snippet = source;
            const newPath = "/snippets/" + this.sectionFilter + "/" + key;
            if (this.$route.path !== newPath) {
              this.$router.push(newPath);
            }
            this.showDetail = true;
          }
        }
      }
    },
    close() {
      this.showDetail = false;
      let newPath =
        "/" +
        this.$route.path
          .substring(1)
          .split("/")
          .shift();
      if (newPath === "/snippets") {
        newPath += "/" + this.sectionFilter;
      }
      if (this.$route.path !== newPath) {
        this.$router.push(newPath);
      }
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      return cls.join(" ");
    }
  }
};
</script>